import { render, staticRenderFns } from "./Basicinfo.vue?vue&type=template&id=40f817ee&scoped=true"
import script from "./Basicinfo.vue?vue&type=script&lang=js"
export * from "./Basicinfo.vue?vue&type=script&lang=js"
import style0 from "./Basicinfo.vue?vue&type=style&index=0&id=40f817ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f817ee",
  null
  
)

export default component.exports